import { observer } from "mobx-react-lite";
import { Fragment, useEffect, useState } from "react";
import "./index.css";
import { LogoutOutlined, RightOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ConfigProvider, Empty, Layout, List } from "antd";
import { Header } from "antd/es/layout/layout";
import InfiniteScroll from "react-infinite-scroll-component";
import {AddCompanyStore, CommonStore, LoginStore} from "../../store";
import AddCompany from "./addCompany";


function ChooseCompany() {
  const navigate = useNavigate();
  const [loading] = useState(false);
  const [dataLength, setDataLength] = useState(0);
  const loadMoreData = () => {
    if (loading) {
      return;
    }
  };

  useEffect(() => {
      LoginStore.getOrgList();
      loadMoreData();
  }, []);

  const navigateTo = async (item: { no: string; displayName: string }) => {
    //绑定企业信息
    await LoginStore.chooseOrganization(item.no);
    navigate("/home");
  };
  const addcompany = () => {
    AddCompanyStore.addCompanyModal.open('add')
  }
  const tableEmptyRender = () => {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<>暂无数据</>}
      ></Empty>
    );
  };
  return (
    <Fragment>
      <AddCompany process='新建'/>
      <div className="body">
        <Layout className="layout">
          <Header>
            <div className="top-left">企业门户</div>
            <div className="header">
              <LogoutOutlined onClick={CommonStore.toLogOut} />
              <span
                className="top-right1"
                style={{ cursor: "pointer" }}
                onClick={CommonStore.toLogOut}
              >
                退出
              </span>
            </div>
          </Header>
        </Layout>

        <div className="list">
          <div style={{ margin: "10px",fontWeight: '400', fontSize: "20px" }}>选择企业账户
            <PlusOutlined className='addIcon' onClick={addcompany}/>
          </div>
          <div className="scrollableDiv">
            <InfiniteScroll
              dataLength={dataLength}
              next={loadMoreData}
              hasMore={true}
              loader={<div className="nothingMore">没有更多了...</div>}
              scrollableTarget="scrollableDiv"
            >
              <ConfigProvider renderEmpty={tableEmptyRender}>
              <List
                dataSource={LoginStore.companyList.opranizationList}
                renderItem={(item: { no: string; displayName: string }) => (
                  <List.Item style={{ fontWeight: '600', fontSize: "18px" ,color: 'rgba(0, 0, 0, 0.88)'}}>
                    {item.displayName}
                    <RightOutlined
                      key={item.no}
                      style={{
                        position: "absolute",
                        right: "0",
                        alignItems: "center",
                      }}
                      onClick={() => {
                        navigateTo(item);
                      }}
                    />
                  </List.Item>
                )}
              />
              </ConfigProvider>
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default observer(ChooseCompany);
